import { Fraction } from "./types";

export const fracToString = (fraction: Fraction) => {
  const [whole, numerator, denomenator] = fraction;
  if (numerator === 0) {
    return whole.toString();
  }
  if (whole === 0) {
    return `<span class="numerator">${numerator}</span>/<span class="denominator">${denomenator}</span>`;
  }
  return `${whole} <span class="numerator">${numerator}</span>/<span class="denominator">${denomenator}</span>`;
};
